<template>
  <form>
    <select-field
      v-model="innerAudienceCategory"
      name="オーディエンスカテゴリー"
      label="オーディエンスカテゴリー"
      :class="`${(innerAudienceCategory == null) ? 'no-category-selected' : ''}`"
      :options="optionAudienceCategory"
      :searchable="false"
      :disabled="isEdit"
      full-width
      return-object
    />
    <div v-if="innerAudienceCategory != null">
      <select-field
        v-model="innerAdvertiser"
        name="広告アカウント"
        label="広告アカウント"
        rules="required"
        class="mt-4"
        :options="optionAdvertisers"
        :searchable="false"
        :disabled="isEdit"
        full-width
      />
      <input-field
        v-model="innerName"
        name="名前"
        label="名前"
        rules="required|max:40"
        class="mt-4"
        :disabled="isEdit"
        full-width
      />
      <input-field
        v-model="innerDescription"
        name="説明"
        label="説明"
        rules="max:500"
        class="mt-4"
        :disabled="isEdit"
        full-width
      />
      <select-field
        v-if="innerAudienceCategory.value === 1 || innerAudienceCategory.value === 2 || innerAudienceCategory.value === 4"
        v-model="innerAudienceType"
        name="オーディエンスタイプ"
        label="オーディエンスタイプ"
        rules="required"
        class="mt-4"
        :options="optionAudienceTypes"
        :disabled="isEdit"
        full-width
      />
      <select-field
        v-if="innerAudienceCategory.value === 2"
        v-model="innerEvent"
        name="イベント"
        label="イベント"
        rules="required"
        class="mt-4"
        :options="optionEvents"
        :max-result-shown="8"
        :searchable="false"
        :disabled="isEdit"
        full-width
        multiple
      />
      <select-field
        v-if="innerAudienceCategory.value === 3"
        v-model="innerOrder"
        name="オーダー"
        label="オーダー"
        rules=""
        class="mt-4"
        :options="optionOrders"
        :max-result-shown="100"
        :disabled="isEdit"
        multiple
        full-width
      />
      <select-field
        v-if="innerAudienceCategory.value === 3"
        v-model="innerLineItem"
        name="ラインアイテム"
        label="ラインアイテム"
        rules=""
        class="mt-4"
        :options="optionLineItems"
        :max-result-shown="100"
        :disabled="isEdit"
        multiple
        full-width
      />
      <select-field
        v-if="innerAudienceCategory.value === 3"
        v-model="innerReachType"
        name="リーチ種別"
        label="リーチ種別"
        rules="required"
        class="mt-4"
        :options="optionReachType"
        :searchable="false"
        :disabled="isEdit"
        full-width
      />
      <div v-if="innerAudienceCategory.value === 2 || innerAudienceCategory.value === 3">
        <div class="vx-row items-end">
          <div class="vx-col w-2/5">
            <input-field
              v-model.number="innerFrequency"
              name="フリークエンシー"
              label="フリークエンシー"
              rules="required"
              class="mt-4"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div v-if="innerAudienceCategory.value === 2" class="vx-col w-3/5">
            <span>回以上</span>
          </div>
          <div v-if="innerAudienceCategory.value === 3" class="vx-col w-3/5">
            <select-field
              v-model="innerFrequencyType"
              name="フリークエンシータイプ"
              label=""
              rules="required"
              class="mt-4"
              :options="optionFrequencyType"
              :allow-empty="false"
              :searchable="false"
              :disabled="isEdit"
              full-width
            />
          </div>
        </div>
      </div>
      <div v-if="innerAudienceCategory.value === 2">
        <div class="vx-row">
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerCategory"
              name="カテゴリー"
              label="カテゴリー"
              class="mt-4"
              :options="optionCategory"
              :searchable="false"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerCategories"
              name="カテゴリー名"
              label=" "
              class="mt-4"
              :options="optionCategories"
              :disabled="innerCategory === null || isEdit"
              :max-result-shown="100"
              full-width
              multiple
            />
          </div>
        </div>
        <text-area-field
          v-model="innerAsin"
          class="mt-4"
          name="ASIN"
          label="ASIN"
          placeholder="改行で複数ASINの一括登録が可能"
          rows="5"
          :disabled="isEdit"
          full-width
        />
        <switch-field
          v-model="innerNewUser"
          name="新規ユーザーに限定"
          label="新規ユーザーに限定"
          class="mt-4"
          :disabled="isEdit"
        />
        <paragraph class="mt-4 text-sm">※オーダー／最初の定期便オーダー／リピート定期便オーダーのイベントは、ブランド新規ユーザーのみにオーディエンスを限定することができます。それ以外のイベントで指定すると対象オーディエンスがゼロになります。</paragraph>
      </div>
      <div v-if="innerAudienceCategory.value === 5">
        <select-field
          v-model="innerSearchKeyword"
          name="検索キーワード"
          label="検索キーワード"
          rules=""
          class="mt-4"
          :options="optionSearchKeywords"
          :options-limit="200"
          :max-result-shown="200"
          :disabled="isEdit"
          full-width
          multiple
        />
        <paragraph class="mt-4 text-sm">※設定されたキーワードのスポンサー広告がインプレッションしたユーザーが対象になります。</paragraph>
      </div>
      <div v-if="innerAudienceCategory.value === 6">
        <select-field
          v-model="innerSegment"
          name="セグメント"
          label="セグメント"
          rules=""
          class="mt-4"
          :options="optionSegments"
          :options-limit="200"
          :max-result-shown="200"
          :disabled="isEdit"
          full-width
          multiple
        />
      </div>
      <div v-if="[2, 3, 5].includes(innerAudienceCategory.value)">
        <select-field
          v-model="innerPeriodType"
          name="期間"
          label="期間"
          class="mt-4"
          rules="required"
          :options="optionPeriodType"
          :searchable="false"
          :disabled="isEdit"
          full-width
        />
        <div v-if="innerPeriodType !== null && innerPeriodType === 1" class="vx-row">
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerPeriodStart"
              name="開始日"
              label="開始日"
              rules="required"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerPeriodEnd"
              name="終了日"
              label="終了日"
              rules="required"
              :disabled="isEdit"
              full-width
            />
          </div>
        </div>
      </div>
      <div v-if="innerAudienceCategory.value === 4">
        <select-field
          v-model="innerEcUserCategory1"
          name="カテゴリー1"
          label="カテゴリー1"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory1"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory2"
          name="カテゴリー2"
          label="カテゴリー2"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory2"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory3"
          name="カテゴリー3"
          label="カテゴリー3"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory3"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory4"
          name="カテゴリー4"
          label="カテゴリー4"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory4"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory5"
          name="カテゴリー5"
          label="カテゴリー5"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory5"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
      </div>
      <div v-if="[2, 3, 4, 5, 6].includes(innerAudienceCategory.value)">
        <select-field
          v-model="innerExceptEvent"
          name="除外イベント"
          label="除外イベント"
          rules=""
          class="mt-4"
          :options="optionEvents"
          :max-result-shown="8"
          :searchable="false"
          :disabled="isEdit"
          full-width
          multiple
        />
        <div class="vx-row">
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerExceptCategory"
              name="除外イベントのカテゴリー"
              label="除外イベントのカテゴリー"
              class="mt-4"
              :options="optionCategory"
              :disabled="innerExceptEvent.length === 0 || isEdit"
              :searchable="false"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerExceptCategories"
              name="除外イベントのカテゴリー名"
              label=" "
              class="mt-4"
              :options="optionExceptCategories"
              :disabled="innerExceptCategory === null || isEdit"
              :max-result-shown="100"
              full-width
              multiple
            />
          </div>
        </div>
        <select-field
          v-model="innerExceptPeriodType"
          name="除外イベントの期間"
          label="除外イベントの期間"
          class="mt-4"
          :rules="(innerExceptEvent.length > 0) ? 'required' : ''"
          :options="optionPeriodType"
          :searchable="false"
          :disabled="innerExceptEvent.length === 0 || isEdit"
          full-width
        />
        <div v-if="innerExceptPeriodType !== null && innerExceptPeriodType === 1" class="vx-row">
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerExceptPeriodStart"
              name="除外イベントの開始日"
              label="除外イベントの開始日"
              rules="required"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerExceptPeriodEnd"
              name="除外イベントの終了日"
              label="除外イベントの終了日"
              rules="required"
              :disabled="isEdit"
              full-width
            />
          </div>
        </div>
      </div>
      <div v-if="innerAudienceCategory.value === 1">
        <select-field
          v-model="innerCategories"
          name="カテゴリー"
          label="カテゴリー"
          rules="required"
          class="mt-4"
          :options="optionCategories"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerAudience1"
          name="オーディエンス①"
          label="オーディエンス①"
          rules="required"
          class="mt-4"
          @update:model-value="onChangeAudience(0, $event)"
          :options="optionAudiences[0]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience2"
          name="オーディエンス②"
          label="オーディエンス②"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(1, $event)"
          :options="optionAudiences[1]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience3"
          name="オーディエンス③"
          label="オーディエンス③"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(2, $event)"
          :options="optionAudiences[2]"
          :max-result-shown="7"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience4"
          name="オーディエンス④"
          label="オーディエンス④"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(3, $event)"
          :options="optionAudiences[3]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience5"
          name="オーディエンス⑤"
          label="オーディエンス⑤"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(4, $event)"
          :options="optionAudiences[4]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience6"
          name="オーディエンス⑥"
          label="オーディエンス⑥"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(5, $event)"
          :options="optionAudiences[5]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
        <select-field
          v-model="innerAudience7"
          name="オーディエンス⑦"
          label="オーディエンス⑦"
          rules=""
          class="mt-4"
          @update:model-value="onChangeAudience(6, $event)"
          :options="optionAudiences[6]"
          :max-result-shown="7"
          :disabled="isEdit"
          full-width
          multiple
          return-object
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import Paragraph from '@/components/Paragraph'
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'
import TextAreaField from '@/components/fields/TextAreaField'
import SwitchField from '@/components/fields/SwitchField'
import DateField from '@/components/fields/DateField'
import USER_RANK from '@/constants/userRank'
import audienceCategory from '@/constants/audienceCategory'

export default {
  name: 'AmcAudienceForm',
  components: {
    Paragraph,
    InputField,
    SelectField,
    TextAreaField,
    SwitchField,
    DateField
  },
  props: {
    audienceCategory: {
      type: Object,
      default: null
    },
    advertiserId: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    params: {
      type: Object,
      default () {
        return {
          audience_type: null,
          event: [],
          order: [],
          line_item: [],
          reach_type: null,
          frequency: null,
          frequency_type: null,
          category: null,
          categories: [],
          asin: null,
          new_user: false,
          search_keyword: [],
          segment: [],
          period: {
            type: null,
            start: null,
            end: null
          },
          except_event: [],
          except_category: null,
          except_categories: [],
          except_period: {
            type: null,
            start: null,
            end: null
          }
        }
      }
    },
    audience1: {
      type: Array,
      default () {
        return []
      }
    },
    audience2: {
      type: Array,
      default () {
        return []
      }
    },
    audience3: {
      type: Array,
      default () {
        return []
      }
    },
    audience4: {
      type: Array,
      default () {
        return []
      }
    },
    audience5: {
      type: Array,
      default () {
        return []
      }
    },
    audience6: {
      type: Array,
      default () {
        return []
      }
    },
    audience7: {
      type: Array,
      default () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:audience-category',
    'update:advertiser-id',
    'update:name',
    'update:description',
    'update:params',
    'update:audience1',
    'update:audience2',
    'update:audience3',
    'update:audience4',
    'update:audience5',
    'update:audience6',
    'update:audience7'
  ],
  data () {
    return {
      selectedCategories: [],
      optionAudiences: []
    }
  },
  computed: {
    ...mapState('amcAudience', ['advertisers', 'categories', 'campaignList', 'lineItemList', 'searchKeywordList', 'segmentList', 'ecUserCategories']),
    ...mapState('amcProfile', ['activeAmcProfile']),
    innerAudienceCategory: {
      get () {
        return this.audienceCategory
      },
      set (val) {
        this.$emit('update:audience-category', val)
      }
    },
    innerAdvertiser: {
      get () {
        return this.advertiserId
      },
      set (val) {
        this.$emit('update:advertiser-id', val)
      }
    },
    innerName: {
      get () {
        return this.name
      },
      set (val) {
        this.$emit('update:name', val)
      }
    },
    innerDescription: {
      get () {
        return this.description
      },
      set (val) {
        this.$emit('update:description', val)
      }
    },
    innerAudienceType: {
      get () {
        return this.params?.audience_type || null
      },
      set (val) {
        this.$emit('update:params', {...this.params, audience_type: ((val !== '') ? val : null)})
      }
    },
    innerEvent: {
      get () {
        return this.params?.event || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, event: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerOrder: {
      get () {
        return this.params?.order || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, order: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerLineItem: {
      get () {
        return this.params?.line_item || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, line_item: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerReachType: {
      get () {
        return this.params?.reach_type || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, reach_type: ((val !== '') ? val : null)})
      }
    },
    innerFrequency: {
      get () {
        return this.params?.frequency || null
      },
      set (val) {
        this.$emit('update:params', {...this.params, frequency: ((val !== '') ? val : null)})
      }
    },
    innerFrequencyType: {
      get () {
        return this.params?.frequency_type || null
      },
      set (val) {
        this.$emit('update:params', {...this.params, frequency_type: ((val !== '') ? val : 1)})
      }
    },
    innerCategory: {
      get() {
        return this.params?.category || null
      },
      set(val) {
        this.$emit('update:params', {...this.params, category: ((val !== '') ? val : null)})
      },
    },
    innerCategories: {
      get () {
        return this.params?.categories || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, categories: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerAsin: {
      get () {
        return this.params?.asin || ''
      },
      set (val) {
        this.$emit('update:params', {...this.params, asin: ((val !== '') ? val : null)})
      }
    },
    innerNewUser: {
      get() {
        return this.params?.new_user || null
      },
      set(val) {
        this.$emit('update:params', {...this.params, new_user: !!val})
      },
    },
    innerSearchKeyword: {
      get() {
        return this.params?.search_keyword || []
      },
      set(val) {
        this.$emit('update:params', {...this.params, search_keyword: ((Array.isArray(val)) ? val : [])})
      },
    },
    innerSegment: {
      get() {
        return this.params?.segment || []
      },
      set(val) {
        this.$emit('update:params', {...this.params, segment: ((Array.isArray(val)) ? val : [])})
      },
    },
    innerPeriodType: {
      get() {
        return this.params?.period?.type || null
      },
      set(val) {
        const type = (val === '') ? null : val
        this.$emit('update:params', {...this.params, period: {type}})
      },
    },
    innerPeriodStart: {
      get() {
        return this.params?.period?.start || null
      },
      set(val) {
        const type = this.params?.period?.type || null
        const period = (type !== 1) ? {type} : {type, start: val || null, end: this.params?.period?.end || null};
        this.$emit('update:params', {...this.params, period})
      },
    },
    innerPeriodEnd: {
      get() {
        return this.params?.period?.end || null
      },
      set(val) {
        const type = this.params?.period?.type || null
        const period = (type !== 1) ? {type} : {type, start: this.params?.period?.start || null, end: val || null};
        this.$emit('update:params', {...this.params, period})
      },
    },
    innerExceptEvent: {
      get() {
        return this.params?.except_event || []
      },
      set(val) {
        const params = {...this.params, except_event: ((Array.isArray(val)) ? val : [])}
        if (!Array.isArray(val) || val.length === 0) {
          delete params['except_category']
          delete params['except_categories']
          delete params['except_period']
        }
        this.$emit('update:params', params)
      },
    },
    innerExceptCategory: {
      get() {
        return this.params?.except_category || null
      },
      set(val) {
        this.$emit('update:params', {...this.params, except_category: ((val !== '') ? val : null)})
      },
    },
    innerExceptCategories: {
      get() {
        return this.params?.except_categories || []
      },
      set(val) {
        this.$emit('update:params', {...this.params, except_categories: ((Array.isArray(val)) ? val : [])})
      },
    },
    innerExceptPeriodType: {
      get() {
        return this.params?.except_period?.type || null
      },
      set(val) {
        const type = (val === '') ? null : val
        this.$emit('update:params', {...this.params, except_period: {type}})
      },
    },
    innerExceptPeriodStart: {
      get() {
        return this.params?.except_period?.start || null
      },
      set(val) {
        const type = this.params?.except_period?.type || null
        const exceptPeriod = (type !== 1) ? {type} : {type, start: val || null, end: this.params?.except_period?.end || null};
        this.$emit('update:params', {...this.params, except_period: exceptPeriod})
      },
    },
    innerExceptPeriodEnd: {
      get() {
        return this.params?.except_period?.end || null
      },
      set(val) {
        const type = this.params?.except_period?.type || null
        const exceptPeriod = (type !== 1) ? {type} : {type, start: this.params?.except_period?.start || null, end: val || null};
        this.$emit('update:params', {...this.params, except_period: exceptPeriod})
      },
    },
    innerEcUserCategory1: {
      get () {
        return this.params?.category1 || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, category1: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerEcUserCategory2: {
      get () {
        return this.params?.category2 || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, category2: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerEcUserCategory3: {
      get () {
        return this.params?.category3 || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, category3: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerEcUserCategory4: {
      get () {
        return this.params?.category4 || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, category4: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerEcUserCategory5: {
      get () {
        return this.params?.category5 || []
      },
      set (val) {
        this.$emit('update:params', {...this.params, category5: ((Array.isArray(val)) ? val : [])})
      }
    },
    innerAudience1: {
      get () {
        return this.audience1
      },
      set (val) {
        this.$emit('update:audience1', val)
      }
    },
    innerAudience2: {
      get () {
        return this.audience2
      },
      set (val) {
        this.$emit('update:audience2', val)
      }
    },
    innerAudience3: {
      get () {
        return this.audience3
      },
      set (val) {
        this.$emit('update:audience3', val)
      }
    },
    innerAudience4: {
      get () {
        return this.audience4
      },
      set (val) {
        this.$emit('update:audience4', val)
      }
    },
    innerAudience5: {
      get () {
        return this.audience5
      },
      set (val) {
        this.$emit('update:audience5', val)
      }
    },
    innerAudience6: {
      get () {
        return this.audience6
      },
      set (val) {
        this.$emit('update:audience6', val)
      }
    },
    innerAudience7: {
      get () {
        return this.audience7
      },
      set (val) {
        this.$emit('update:audience7', val)
      }
    },
    profileCategory () {
      if (this.activeAmcProfile.hasOwnProperty('params') &&
        this.activeAmcProfile.params.hasOwnProperty('type3') &&
        this.activeAmcProfile.params.type3.hasOwnProperty('==CATEGORY==')) {
          return this.activeAmcProfile.params['type3']['==CATEGORY=='];
      }
      return 'brand'
    },
    optionAudienceCategory () {
      return Object.keys(audienceCategory).map((key)=> {
        if (Number(key) === 4 && this.ecUserCategories && this.ecUserCategories.hasOwnProperty('disabled')) {
          return {text: audienceCategory[key], value: Number(key), $isDisabled: this.ecUserCategories['disabled']}
        }
        return {text: audienceCategory[key], value: Number(key), $isDisabled: false}
      })
    },
    optionAdvertisers () {
      return this.advertisers.map(({id, name}) => (
        {text: `${id}:${name}`, value: id}
      ))
    },
    optionAudienceTypes () {
      return [
        {text: '通常', value: 'RULE_BASED'},
        {text: 'Most similar', value: 'MOST_SIMILAR'},
        {text: 'Similar', value: 'SIMILAR'},
        {text: 'Balanced', value: 'BALANCED'},
        {text: 'Broad', value: 'BROAD'},
        {text: 'Most broad', value: 'MOST_BROAD'}
      ]
    },
    optionCategory() {
      return [
        { text: 'ブランド', value: 'brand' },
        { text: '出品者カテゴリー', value: 'seller_category' },
        { text: '出品者カテゴリー2', value: 'seller_category2' },
        { text: '出品者カテゴリー3', value: 'seller_category3' },
        { text: '出品者カテゴリー4', value: 'seller_category4' },
        { text: '出品者カテゴリー5', value: 'seller_category5' },
      ];
    },
    optionCategories () {
      if (this.innerAudienceCategory === null) return []
      if (this.innerAudienceCategory.value === 1) {
        return this.categories[this.profileCategory].map((item) => (
          {text: item, value: item}
        ))
      }
      if (this.innerCategory === null) return []
      return this.categories[this.innerCategory].map((item) => (
        {text: item, value: item}
      ))
    },
    optionEvents () {
      return [
        {text: 'レビューページ閲覧', value: 'customerReview'},
        {text: 'ページビュー', value: 'detailPageView'},
        {text: 'オーダー', value: 'order'},
        {text: 'ショッピングカート', value: 'shoppingCart'},
        {text: '定期便登録', value: 'snsSubscription'},
        {text: '最初の定期便オーダー', value: 'firstSnSOrder'},
        {text: 'リピート定期便オーダー', value: 'repeatSnSOrder'}
      ]
    },
    optionOrders () {
      return this.campaignList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionLineItems () {
      return this.lineItemList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionReachType () {
      return [
        {text: 'viewable_impressions', value: 1},
        {text: 'impressions', value: 2},
        {text: '動画再生開始', value: 3},
        {text: '動画視聴完了', value: 4},
      ]
    },
    optionFrequencyType () {
      return [
        {text: '回以上', value: 1},
        {text: '回以下', value: 2},
      ]
    },
    optionPeriodType () {
      return [
        {text: '日付指定', value: 1},
        {text: '過去7日', value: 2},
        {text: '過去14日', value: 3},
        {text: '過去30日', value: 4},
        {text: '過去60日', value: 5},
        {text: '過去90日', value: 6},
        {text: '過去120日', value: 7},
        {text: '過去180日', value: 8},
        {text: '過去270日', value: 9},
        {text: '過去365日', value: 10},
      ]
    },
    optionSearchKeywords () {
      return this.searchKeywordList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionSegments () {
      return this.segmentList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionExceptCategories () {
      if (this.innerAudienceCategory === null) return []
      if (this.innerAudienceCategory.value === 1) {
        return this.categories[this.profileCategory].map((item) => (
          {text: item, value: item}
        ))
      }
      if (this.innerExceptCategory === null) return []
      return this.categories[this.innerExceptCategory].map((item) => (
        {text: item, value: item}
      ))
    },
    optionEcUserCategory1 () {
      return (this.ecUserCategories?.hasOwnProperty('category1')) ?
        this.ecUserCategories['category1'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory2 () {
      return (this.ecUserCategories?.hasOwnProperty('category2')) ?
        this.ecUserCategories['category2'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory3 () {
      return (this.ecUserCategories?.hasOwnProperty('category3')) ?
        this.ecUserCategories['category3'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory4 () {
      return (this.ecUserCategories?.hasOwnProperty('category4')) ?
        this.ecUserCategories['category4'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory5 () {
      return (this.ecUserCategories?.hasOwnProperty('category5')) ?
        this.ecUserCategories['category5'].map((c) => ({text: c, value: c})) : []
    }
  },
  created () {
    this.resetOption()
  },
  methods: {
    onChangeAudience (key, data) {
      // 変更前と変更後
      const audiences = [this.audience1, this.audience2, this.audience3, this.audience4, this.audience5, this.audience6, this.audience7];
      const before = audiences[key].map(({value}) => value)
      const after = data.map(({value}) => value)
      // 追加と削除されたユーザーランク
      const add = after.filter(i => before.indexOf(i) === -1)
      const remove = before.filter(i => after.indexOf(i) === -1)
      for (const i in audiences) {
        // 今回操作した以外のオーディエンスが対象
        if (Number(i) !== key) {
          if (add.length > 0) {
            // 追加されたのでその他のオーディエンスから無効化
            const index = this.optionAudiences[i].findIndex(({value})=> value == add[0])
            this.optionAudiences[i][index]['$isDisabled'] = true
          } else if (remove.length > 0) {
            // 削除されたのでその他のオーディエンスから有効化
            const index = this.optionAudiences[i].findIndex(({value})=> value == remove[0])
            this.optionAudiences[i][index]['$isDisabled'] = false
          }
        }
      }
    },
    // MEMO: 登録直後に親コンポーネントから呼ばれる。$isDisabledを全てfalseに戻すために必要。
    resetOption () {
      this.optionAudiences = [
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
        Object.keys(USER_RANK).map((key) => ({text: USER_RANK[key], value: key, $isDisabled: false})),
      ]
    }
  }
}
</script>
